import React, { type JSX } from 'react';
import { Box, Container, useTheme } from '@mui/material';
import { usePage } from '@inertiajs/react';

import { FlashMessage, TFlashMessage } from '@/core/ui/FlashMessage';

type Props = {
  children?: React.ReactElement;
};

type PageProps = {
  flash: TFlashMessage;
};

export default function Guest({ children }: Props): JSX.Element {
  const { palette } = useTheme();

  const {
    props: { flash },
  } = usePage<PageProps>();

  return (
    <Container
      maxWidth="sm"
      sx={{
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
        minHeight: '100vh',
        alignItems: 'center',
        p: 4,
      }}
    >
      <FlashMessage flash={flash} position="2rem" />
      <Box
        sx={{
          backgroundColor: palette.common.white,
          p: 6,
          borderRadius: 1,
          boxShadow: '0 3px 8px rgb(0 0 0 / 10%)',
        }}
      >
        {children}
      </Box>
    </Container>
  );
}
